import { Button } from '@goodfynd/react-web.lib.ui';
import { styled } from '@goodfynd/react-web.theme';

import LikeButton from '../LikeButton';
import ShareButton from '../ShareButton';

export const GroupNameContainer = styled('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

export const StyledAddButton = styled(Button, {
  flex: 1,
  marginLeft: 32,
});

export const StyledImageContainer = styled('div', {
  height: 248,
  position: 'relative',
});

export const StyledLikeButton = styled(LikeButton, {
  left: '1rem',
  position: 'absolute',
  top: '1rem',
  zIndex: 1,
});

export const StyledModalContent = styled('div', {
  padding: 24,
  paddingBottom: 112,
  '@sm': {
    padding: 16,
    paddingBottom: 88,
  },
});

export const StyledProductOptionsContainer = styled('section', {
  position: 'relative',
});

export const StyledProductOptionsContainerDisabled = styled('section', {
  bottom: 0,
  height: '100%',
  left: 0,
  position: 'absolute',
  width: '100%',
  zIndex: 1,
});

export const StyledProductOptionsGroup = styled('section', {
  marginTop: 24,
});

export const StyledRequestsContainer = styled('section', {
  // backgroundColor: '$Neutral01',
  margin: '0 -24px',
  marginTop: 16,
  padding: 24,
});

export const StyledShareButton = styled(ShareButton, {
  left: '4.5rem',
  position: 'absolute',
  top: '1rem',
  zIndex: 1,
});

export const StyledStickyBottom = styled('div', {
  alignItems: 'center',
  display: 'flex',
  bottom: 0,
  justifyContent: 'space-between',
  padding: '16px 24px',
  '@sm': {
    padding: '8px 16px',
  },
});
